import { Controller } from '@hotwired/stimulus'
import { plural } from '@lingui/core/macro'

export default class extends Controller {
  static values = {
    debounceMs: { type: Number, default: 50 }, // 50ms debounce
  }

  connect() {
    // Sync on connect (initial page load)
    this.syncContent()

    // Listen for Turbo Stream updates to hidden source
    this.setupTurboStreamListener()

    // Also sync when dropdown is shown (for good measure)
    this.element.addEventListener('show.bs.dropdown', this.syncContent.bind(this))

    // Initialize debounce timer
    this.debounceTimer = null
  }

  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this.handleStreamRender.bind(this))
    this.element.removeEventListener('show.bs.dropdown', this.syncContent.bind(this))
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }

  setupTurboStreamListener() {
    document.addEventListener('turbo:before-stream-render', this.handleStreamRender.bind(this))
  }

  handleStreamRender(event) {
    const action = event.detail.newStream

    if (action.target === 'notification-dropdown-hidden-source') {
      this.debouncedSyncContent()
    }
  }

  debouncedSyncContent() {
    // Clear existing timer
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    // Schedule new sync after debounce period
    this.debounceTimer = setTimeout(() => {
      this.syncContent()
      this.debounceTimer = null
    }, this.debounceMsValue)
  }

  syncContent() {
    // Get the hidden source with all notifications
    const source = document.getElementById('notification-dropdown-hidden-source')

    // Get the visible dropdown
    const visibleDropdown = this.element.querySelector('.notification-dropdown-body')
    const dropdownHeader = this.element.querySelector('.notification-dropdown-header')

    if (source && visibleDropdown) {
      // Copy the content from the hidden source (which contains the dropdown-list-content div)
      const listContent = source.querySelector('#notification-dropdown-list-content')
      if (listContent) {
        visibleDropdown.innerHTML = listContent.innerHTML
      }

      // Sync unread count in header
      const unreadCountElement = source.querySelector('#notification-unread-count')
      if (unreadCountElement && dropdownHeader) {
        const count = parseInt(unreadCountElement.getAttribute('data-count'), 10)

        // Find or create the count span
        let headerCountSpan = dropdownHeader.querySelector('.notification-dropdown-count')

        if (count > 0) {
          if (!headerCountSpan) {
            // Create the span if it doesn't exist
            headerCountSpan = document.createElement('span')
            headerCountSpan.className = 'notification-dropdown-count'
            dropdownHeader.appendChild(headerCountSpan)
          }
          headerCountSpan.textContent = plural(count, {
            one: '# new',
            other: '# new',
          })
        } else if (headerCountSpan) {
          // Remove the span if count is 0
          headerCountSpan.remove()
        }
      }
    }
  }
}
